import React from "react";
import "../../App.css";

// Full footer for the Home page
function HomePageFooter({ handleNavClick }) {
  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Find Us - Left */}
        <div className="footer__col">
          <h3 className="footer__title">Find Us</h3>
          <p className="footer_subtitle">Registered / corporate Office :</p>
          <p>7/170, 6th Street, Astalakshmi Nagar, Alapakkam, Chennai - 600 116</p>
          <p className="footer_subtitle">Sales Office :</p>
          <p>No.54/81, First Floor, Bazullah road, T.Nagar, Chennai 600017.</p>
          <p className="footer_subtitle">Singapore branch :</p>
          <p>20, Collyer Quay, #09-01, Singapore - 049319</p>
        </div>

        {/* Quick Links + GEOTECH - Center */}
        <div className="footer__col footer__center">
          <h1 className="footer__quick-title">Quick Links</h1>
          <div className="footer__links-horizontal">
            <p className="footer__nav-link" onClick={() => handleNavClick("home")}>Home</p>
            <p className="footer__nav-link" onClick={() => handleNavClick("aboutus")}>About</p>
            <p className="footer__nav-link" onClick={() => handleNavClick("products-landing")}>Products</p>
            <p className="footer__nav-link" onClick={() => handleNavClick("contactus")}>Contact</p>
          </div>

          <img src="logo.jpg" alt="GEOTECH Logo" className="footer__logo" />
          <h2 className="footer__brand">GEOTECH</h2>
          <p className="footer__tagline">
            Empowering Users in the Field of GIS, IT, Health, Environment, Agriculture, Education & Research
          </p>
        </div>

        {/* Email and Contact - Right */}
        <div className="footer__col footer__right">
          <div className="footer__contact">
            <h3 className="footer__title">Email Us</h3>
            <p>geotech.indiasales@gmail.com</p>
            <p>ravi@geotechgeospatial.com</p>

            <h3 className="footer__title">Call Us</h3>
            <p>+91 98405 08463</p>
            <p>91-44-28340094</p>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© 2025 GEOTECH | Designed by Caarapace</p>
      </div>
    </footer>
  );
}

// Simple footer for other pages
function SimpleFooter({ handleNavClick }) {
  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Find Us - Left */}
        <div className="footer__col">
          <h3 className="footer__title">Find Us</h3>
          <p className="footer_subtitle">Registered / corporate Office :</p>
          <p>7/170, 6th Street, Astalakshmi Nagar, Alapakkam, Chennai - 600 116</p>
          <p className="footer_subtitle">Sales Office :</p>
          <p>No.54/81, First Floor, Bazullah road, T.Nagar, Chennai 600017.</p>
          <p className="footer_subtitle">Singapore branch :</p>
          <p>20, Collyer Quay, #09-01, Singapore - 049319</p>
        </div>

        {/* Quick Links + GEOTECH - Center */}
        <div className="footer__col footer__center">
          <h1 className="footer__quick-title">Quick Links</h1>
          <div className="footer__links-horizontal">
            <p className="footer__nav-link" onClick={() => handleNavClick("home")}>Home</p>
            <p className="footer__nav-link" onClick={() => handleNavClick("aboutus")}>About</p>
            <p className="footer__nav-link" onClick={() => handleNavClick("products-landing")}>Products</p>
            <p className="footer__nav-link" onClick={() => handleNavClick("contactus")}>Contact</p>
          </div>

          <img src="logo.jpg" alt="GEOTECH Logo" className="footer__logo" />
          <h2 className="footer__brand">GEOTECH</h2>
          <p className="footer__tagline">
            Empowering Users in the Field of GIS, IT, Health, Environment, Agriculture, Education & Research
          </p>
        </div>

        {/* Email and Contact - Right */}
        <div className="footer__col footer__right">
          <div className="footer__contact">
            <h3 className="footer__title">Email Us</h3>
            <p>geotech.indiasales@gmail.com</p>
            <p>ravi@geotechgeospatial.com</p>

            <h3 className="footer__title">Call Us</h3>
            <p>+91 98405 08463</p>
            <p>91-44-28340094</p>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© 2025 GEOTECH. All Rights Reserved.</p>
        <span className="footer__credit">Designed by Caarapace</span>
      </div>
    </footer>
  );
}

export { HomePageFooter, SimpleFooter };